// Dynamic API URL: use current origin on production domain, env var otherwise
const getApiUrl = () => {
  const origin = window.location.origin;
  if (origin.includes('mblavatsky.com')) {
    return `${origin}/api`;
  }
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

const API = getApiUrl();

const getCardSymbol = (id) => {
  const symbols = ['☆', '✧', '☾', '♕', '♔', '✦', '♥', '⚔', '☼', '⚶', '⟳', '⚖', '⚹', '☠', '⚗', '♦', '⚡', '★', '☽', '☀', '⚜', '✪'];
  return symbols[id % symbols.length];
};

export { API, getCardSymbol };
